import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FlagReason} from '../../types/flag-reason';
import {NoteService} from '../../services/note_service';

@Component({
  selector: 'app-report-comment-modal',
  templateUrl: './report-comment-modal.component.html',
  styleUrls: ['./report-comment-modal.component.scss']
})

export class ReportCommentModalComponent implements OnInit {
  @Input()
  public commentId: string;
  public postId: any;

  public comment: string;
  public flagReasonKeys;
  public flagReasons = FlagReason;
  public reason;
  constructor(public activeModal: NgbActiveModal, public noteService: NoteService) { }

  ngOnInit() {
    this.flagReasonKeys = Object.keys(FlagReason).filter(Number);
  }

  // TODO: get flag reason from selected radio button
  reportComment() {
    this.noteService.flagComment(this.postId, this.commentId, this.reason, this.comment)
      .then(() => {
        this.activeModal.close();
      })
      .catch((err) => {
        this.activeModal.dismiss('Error flagging comment');
      });
  }

  onFlagReasonChange(flagReason) {
    this.reason = flagReason;
  }

}
